import './App.css';
import React from "react";
import App from "./App";
import {store} from "./store";

import { Provider, ErrorBoundary } from '@rollbar/react'; // Provider imports 'rollbar'

import { useRollbar } from '@rollbar/react';
import MultiLocationApp from "./MultiLocationApp";

const rollbarConfig = {
    accessToken: '3149ab39120643888da85e87a1896c7b',
    captureUncaught: true,
    captureUnhandledRejections: true,
    environment: 'production',
};

function AppWithRollbar({renderKey}) {
    const rollbar = useRollbar();
    return <App key={renderKey} rollbar={rollbar} />;
}

class AppContainer extends React.Component{

    constructor(props) {
        super(props)
        this.state = {
            wsToken: "",
            hasMultipleLocations: false
        }
    }

    componentDidMount() {
        this.setState({wsToken: store.getState().wsToken})


        store.subscribe(() => {
            var token = store.getState().wsToken
            if(token !== this.state.wsToken){
                this.setState({wsToken: token})
            }

            var location = store.getState().location
            if(location.multiLocation !== this.state.hasMultipleLocations){
                this.setState({hasMultipleLocations: location.multiLocation})
            }
        })
    }

    render() {
        console.error("Muli locations: ", this.state.hasMultipleLocations)
        return(
            <>
                <Provider config={rollbarConfig}>
                    <ErrorBoundary>
                        {this.state.hasMultipleLocations? <MultiLocationApp /*renderKey={this.state.wsToken}*//> : <AppWithRollbar renderKey={this.state.wsToken}/>}

                </ErrorBoundary>
                </Provider>
            </>
        )
    }
}


export default AppContainer;